import { createFileRoute, redirect } from "@tanstack/react-router";

// Back-compat: invitee links used to be /interview/session/{token}. Invites are now distributions
// whose slug is the old token, so redirect to the unified /interview/{slug} page — previously
// emailed/bookmarked invite links keep working.
export const Route = createFileRoute("/interview/session/$token")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/interview/$slug", params: { slug: params.token } });
  },
});
